export default __webpack_public_path__ + "static/media/connect_without_contact_black_24dp.1c9fe2ea.svg";